import { Auth } from 'aws-amplify';
import { SetAccessToken } from '../store/slice/auth.slice';

export const refreshToken = async (dispatch: any) => {
    try {
        const currentUser = await Auth.currentAuthenticatedUser();
        const refreshToken = (await Auth.currentSession()).getRefreshToken();

        const refreshedSession: any = await new Promise((resolve, reject) => {
            currentUser.refreshSession(refreshToken, (err: any, session: any) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(session);
                }
            });
        });

        const accessToken = refreshedSession.getAccessToken().getJwtToken();
        dispatch(SetAccessToken(accessToken));
    } catch (e) {}
};
